export const API_HOST = process.env.REACT_APP_API_HOST;
export const SOCKET_API_HOST = process.env.REACT_APP_SOCKET_API_HOST;
export const DEFAULT_PER_PAGE = process.env.REACT_APP_DEFAULT_PER_PAGE;
export const DEFAULT_DOMAINS_PER_PAGE = process.env.REACT_APP_DEFAULT_DOMAINS_PER_PAGE;
export const DEFAULT_DOMAIN_OVERVIEW_DRAWER_WIDTH = process.env.REACT_APP_DEFAULT_DOMAIN_OVERVIEW_DRAWER_WIDTH;
export const DEFAULT_FLAG_SIZE = process.env.REACT_APP_DEFAULT_FLAG_SIZE;